import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import style from '../engagement-card.module.less';
import { messages } from '../messages';

export const TagYourOrdersBody = () => {
  return (
    <FlexColumn>
      <Text className={style['card-text']} textType={TextType.Paragraph} value={messages.tagYourOrdersBody} />
      <Text className={style['card-text']} textType={TextType.Paragraph} value={messages.tagYourOrdersSubText} />
    </FlexColumn>
  );
};
